<div class="ss">
  <header class="ss__hero">
    <div class="ss__eyebrow">
      <span class="ss__eyebrow-rule" aria-hidden="true"></span>
      Frage
    </div>
    <h2 class="ss__title cr-display">{{ node.question }}</h2>
    @if (node.helpText) {
      <p class="ss__lead">{{ node.helpText }}</p>
    }
  </header>

  <div class="ss__tiles">
    @for (opt of node.options; track opt.value) {
      @let active = currentValue() === opt.value;
      <button
        type="button"
        class="ss__tile"
        [class.ss__tile--active]="active"
        [attr.aria-pressed]="active"
        (click)="pick(opt.value)">
        <span class="ss__glyph cr-mono" [class.ss__glyph--active]="active">
          {{ glyphFor(opt.label) }}
        </span>
        <span class="ss__tile-label">{{ opt.label }}</span>
        @if (active) {
          <svg class="ss__tile-check" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="m5 12 5 5 9-11"/>
          </svg>
        }
      </button>
    }
  </div>
</div>
